module.exports = __webpack_public_path__ + "img/ci.f2aff5d6.png";